import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ComboBoxOption } from "@typings/components/comboBox";
import type { GetUsersResponse } from "./type";
import { ROLES } from "@typings/entities/users/enums";

export async function searchUsers(
  query?: string,
  role?: string,
): Promise<ComboBoxOption[]> {
  const params = new URLSearchParams();

  const trimmedQuery = query?.trim();

  if (trimmedQuery) {
    params.append("search", trimmedQuery);
  }

  if (role) {
    params.append("role", role);
  }

  const url = params.toString()
    ? `${apiPaths.users.list}?${params.toString()}`
    : apiPaths.users.list;

  const response = await apiClient.get<GetUsersResponse>(url);

  return response.data.items.map((item) => ({
    label: item.username,
    value: item.id,
  }));
}

export const searchPpmaUsers = (query?: string) =>
  searchUsers(query, ROLES.PMMA);
